/**
 * Tool Error Classes
 * 
 * Standardized error types for tool execution.
 * 
 * @see docs/Research/DesignSpecsClaude.md Section 7
 */

/**
 * Error thrown by tools during execution.
 */
export class ToolError extends Error {
  constructor(
    /** Error category */
    public readonly type: 'ValidationError' | 'ExecutionError' | 'ConfigurationError',
    /** Human-readable message */
    message: string,
    /** Additional details for debugging */
    public readonly details?: {
      line?: number;
      column?: number;
      suggestion?: string;
      [key: string]: unknown;
    }
  ) {
    super(message);
    this.name = 'ToolError';
  }

  /**
   * Create a validation error (input doesn't match expected format).
   */
  static validation(message: string, details?: Record<string, unknown>): ToolError {
    return new ToolError('ValidationError', message, details);
  }

  /**
   * Create an execution error (error during processing).
   */
  static execution(message: string, details?: Record<string, unknown>): ToolError {
    return new ToolError('ExecutionError', message, details);
  }

  /**
   * Create a configuration error (invalid tool config).
   */
  static configuration(message: string, details?: Record<string, unknown>): ToolError {
    return new ToolError('ConfigurationError', message, details);
  }
}

